export default __webpack_public_path__ + "static/media/holi.e8ae21b9.png";